<template>
  <div :id="id"></div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'echart',
  data () {
    return {}
  },
  props: {
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    id: {
      type: String,
      default: 'container'
    }
  },
  mounted () {
    const myChart = echarts.init(document.getElementById(this.id))
    myChart.setOption(this.option, true)
    window.addEventListener('resize', function () {
      setTimeout(() => {
        myChart.resize()
      }, 100)
    })
  }
}
</script>
